import Vue from 'vue'

Vue.directive('horizontal-drag-scrolling', function (el, binding) {
  el.style.cursor = 'grab'

  el.addEventListener('mousedown', function (e) {
    binding.value.isMousedown = true
    el.style.cursor = 'grabbing'
    binding.value.startX = e.pageX - el.offsetLeft
    binding.value.scrollLeft = el.scrollLeft
  })

  el.addEventListener('mouseup', function (e) {
    binding.value.isMousedown = false
    el.style.cursor = 'grab'
  })

  el.addEventListener('mouseleave', function (e) {
    binding.value.isMousedown = false
    el.style.cursor = 'grab'
  })

  el.addEventListener('mousemove', function (e) {
    if (!binding.value.isMousedown) return
    e.preventDefault()
    const x = e.pageX - el.offsetLeft
    const move = (x - binding.value.startX) * 3 // scroll speed
    el.scrollLeft = binding.value.scrollLeft - move
  })
})
